module.exports = __webpack_public_path__ + "img/europeana.1b19285e.jpg";